module.exports = __webpack_public_path__ + "img/close-circle.f6f16d27.svg";